import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TranslateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"translate"}/>
}
